module.exports = __webpack_public_path__ + "static/img/case_banner_10.06c19f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_10.png
// module id = BKNe
// module chunks = 34